<template>
  <div id="environment-and-social-contribution">
    <call />
    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right push-to-right-grey">
        <div class="l-header__column l-header__column--left pl-16">
          <div class="l-header__btn-menu ssm-toggle-nav">
            <img src="/assets/images/icon/icon_menu_black.svg" class="l-header__btn-menu--open" />
            <img src="/assets/images/icon/icon-close.svg" class="l-header__btn-menu--close" />
          </div>
        </div>
        <div class="l-header__column l-header__column--mid">
          環境・社会貢献
        </div>
        <div class="l-header__column l-header__column--right pr-61"></div>
      </div>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white pb-50">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                環境保全・社会貢献活動
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-8">
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__name mb-15">
                  イオンタウン環境方針
                </div>
                <div class="c-about-group__title mb-0">
                  イオンタウンは、資源エネルギーを有効に活用し、サービスの質を高めながらも、環境への影響を最小にするショッピングセンター（SC）づくりを通じて、持続可能な社会の実現をめざします。<br />
                  そのため、環境方針を以下のとおり定め、あわせて、多くのお客さまとのコミュニケーションと地域貢献の履行に努めてまいります。
                  <br /><br />
                  １．イオンタウンは、気候変動の緩和及び気候変動への適応に貢献します。<br />
                  ２．イオンタウンは、地球資源を保全し、循環型社会の構築をめざすため、ゼロエミッションSCを実現します。<br />
                  ３．イオンタウンは、生物多様性及び生態系の保護を推進します。<br />
                  ４．イオンタウンは、お客さまをはじめとするパートナーさまの生活環境の向上と、地域社会の発展と環境保全に貢献します。<br />
                  ５．イオンタウンは、環境法規制や当社が受け入れを決めた要求事項を順守します。<br />
                  ６．イオンタウンは、従業員全員で環境意識を高め、お客さま・パートナーさまと取り組みの輪を広げていきます。<br />
                  ７．イオンタウンは、この方針を当社従業員及びともに働く従業員に周知します。
                </div>
                <div class="c-about-group__image mt-10">
                  <img src="/assets/images/demo/environtment_1.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Menu from "../components/Menu.vue";
import { Common } from "../common/common.js";
import Vue from "vue";
export default Vue.extend({
  name: 'EnvironmentAndSocialContribution',
  components: {
    'menu-app': Menu
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  }
})
</script>